<script>
export default {
  name: 'Status',
  inheritAttrs: false,
  props: {
    status: {
      type: String,
      required: true,
    },
    inactiveStyle: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    styleObj() {
      switch (this.status) {
        case 'active': return { color: '#0fbd1c' }
        case 'inactive': return { color: 'red', opacity: 0.4 }
        default: return { color: 'gray', opacity: 0.4 }
      }
    },
  },
}
</script>

<template>
  <div
    :class="$style.container"
    :style="styleObj"
  >
    <div :class="$style.badge" />
    {{ `${status.charAt(0).toUpperCase()}${status.slice(1)}` }}
  </div>
</template>

<style lang="scss" module>
.container {
  display: flex;
  align-items: center;
}

.badge {
  width: rem(10px);
  height: rem(10px);
  margin-right: rem(10px);
  background-color: currentColor;
  border-radius: 50%;
}
</style>
